<app-chat-message-text
  *ngIf="isContent"
  [message]="message"
  [isMine]="isMine"
  [previousMessage]="previousMessage"
  [template]="template"
  [translationData]="translationData"
></app-chat-message-text>
<app-chat-message-event
  *ngIf="isEventSystem"
  [message]="message"
  [isMine]="isMine"
  [previousMessage]="previousMessage"
  [translationData]="translationData"
></app-chat-message-event>
<app-chat-message-confirm
    *ngIf="isEventButton"
    [message]="message"
    [translationData]="translationData"
></app-chat-message-confirm>